// extracted by mini-css-extract-plugin
module.exports = {"layout":"SideLayout_layout__3476J","layout__content":"SideLayout_layout__content__n0oiP"};